import { Component, inject, Input, Output, signal } from '@angular/core'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { Subject } from 'rxjs'
import { PracticeBatchInfo } from 'src/app/shared/services/ppv.api'

@Component({
   selector: 'vc-practice-settings-modal',
   templateUrl: './practice-settings-modal.component.html',
   styleUrl: './practice-settings-modal.component.scss',
   standalone: false,
})
export class VetcorPracticeSettingsModalComponent {
   @Input() settingsForPractice = signal<PracticeBatchInfo>(null)
   @Input() statusOptions: { label: string; value: number }[]
   @Input() pricingPartnerOptions: {
      pricingCaptainUserId: number
      workEmail: string
      displayName: string
   }[]
   @Input() selectedPricingPartner: number | null = null

   @Input() onResetBatch = new Subject<PracticeBatchInfo>()
   @Input() onDateChange = new Subject<{ newDate: any; column: string }>()
   @Input() onValueChange = new Subject<{ newValue: any; column: string }>()
   @Input() onPricingPartnerChange = new Subject<{ newValue: any }>()

   private bsModalRef: BsModalRef = inject(BsModalRef)

   onClose() {
      this.bsModalRef.hide()
   }

   onSave() {
      this.onResetBatch.next(this.settingsForPractice())
      this.bsModalRef.hide()
   }

   handlePricingPartnerChange(newValue: any): void {
      var newPricingPartner = this.pricingPartnerOptions?.find((p) => p.pricingCaptainUserId === newValue)
      this.onPricingPartnerChange.next({ newValue: newPricingPartner })
   }
}
